'use client';

import { CONSENT_EVENTS } from '@repo/analytics';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { gtmDataLayerAdapter } from '@/lib/analytics/gtm-data-layer-adapter';
import { updateConsent } from '@/lib/analytics/update-consent';
import { COOKIE_CONSENT_KEY, resolveGeoConsentRequired } from '@/lib/cookie-consent';

const CookieConsentBanner = dynamic(
  () => import('./cookie-consent-banner').then((mod) => mod.CookieConsentBanner),
  { ssr: false },
);

function alreadyDecided(): boolean {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    return stored === 'accepted' || stored === 'rejected';
  } catch {
    return false;
  }
}

export function CookieConsentBannerLoader(): React.JSX.Element | null {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (alreadyDecided()) {
      return;
    }
    let cancelled = false;
    resolveGeoConsentRequired().then((required) => {
      if (cancelled) {
        return;
      }
      if (required) {
        setShowBanner(true);
      } else {
        updateConsent(true);
        gtmDataLayerAdapter.track(CONSENT_EVENTS.granted);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!showBanner) {
    return null;
  }
  return <CookieConsentBanner />;
}
